module.exports = __webpack_public_path__ + "static/goldbg-88b38110707974c20027ee4bc5b7d841.jpg";